export const SET_AREA = "SET_AREA";
export const SET_PLAN = "SET_PLAN";